<template>
  <div id="form2">
    <h2>Lückentext</h2>
    <br><br>
    <p style="text-align: left;">
        In der Signalverarbeitung wird bei der Abtastung ein <input v-model="message8" placeholder="Feld1" /> Signal zu einem 
        <input v-model="message9" placeholder="Feld2" /> Signal reduziert.
    </p>
    <p style="text-align: left;">
        Um ohne <input v-model="message10" placeholder="Feld3" /> ein analoges Signal zu rekonstruieren, wird das Ursprungssignal mit mindestens der 
        <input v-model="message11" placeholder="Feld4" /> Frequenz (<input v-model="message12" placeholder="Feld5" />) abgetastet.
    </p>
    <p style="text-align: left;">
        Geschieht dies nicht, wird ein Tiefpass-Filter eingesetzt, um ein <input v-model="message13" placeholder="Feld6" /> vorzubeugen.
    </p>

    <button id="button3" v-on:click="check2">
        Prüfen
    </button>

  </div>
</template>
<script>

export default {
  name: "two-lists",
  display: "Two Lists",
  order: 1,

  data() {
    return {
        message8: '',
        message9: '',
        message10: '',
        message11: '',
        message12: '',
        message13: '',
    }
  },
  methods: {
    log: function(evt) {
      window.console.log(evt);
    },
    check2()  {
        if ( (this.message8 && this.message8 == "Zeitkontinuierliches" || this.message8 == "zeitkontinuierliches") &&
             (this.message9 && this.message9 == "Zeitdiskreten" || this.message9 == "zeitdiskreten") &&
             (this.message10 && this.message10 == "Informationsverlust" || this.message10 == "informationsverlust") &&
             (this.message11 && this.message11 == "Doppelten" || this.message11 == "doppelten") &&
             (this.message12 && this.message12 == "Abtasttheorem" || this.message12 == "abtasttheorem") &&
             (this.message13 && this.message13 == "Aliasing" || this.message13 == "aliasing")
            ){
                alert("richtig");
                this.$store.commit('setTaskCompletionState', {varname: "audioForm3_done", state: true})
                localStorage.setItem("audioForm3_done", true);
            }
        else {
            alert("falsch")
        }
    }
  }
};
</script>

<style scoped>
/* #input1 {
    position: absolute;
    left: 260px;
    top: 305px
} */
/* #input2 {
    position: absolute;
    left: 530px;
    top: 205px
} */
#button3 {
    position: absolute;
    left: 650px;
    top: 550px;
    font-family: sans-serif;
    font-size: 20px;
    /* background-color: #297; */
    color: #fff;
    border: 0px;
    border-radius: 3px;
    padding: 20px;
    cursor: pointer;
    margin-bottom: 20px;
    background-color: #528382
}
#form2 {
    height: 1000px;;
}
</style>